import css from './FragmentInfoMobileDropdown.module.css';
import React from 'react';
import DropdownButton from '@shared/Ui/Buttons/DropdownButton/DropdownButton';

interface FragmentInfoMobileDropdownProps {
    imgUrl?: string;
    isExpanded?: boolean;
    toggleExpand: () => void;
    isLaborAndTools: boolean;
    fragmentTitle?: string;
    description?: string;
}

export const FragmentInfoMobileDropdown: React.FC<
    FragmentInfoMobileDropdownProps
> = ({
    imgUrl,
    toggleExpand,
    isExpanded,
    isLaborAndTools,
    fragmentTitle,
    description,
}) => {
    return isLaborAndTools ? (
        <div className={css.dropdown}>
            <div className={css.title}>
                {fragmentTitle}
                <div className={css.description}>{description}</div>
            </div>
            <DropdownButton onClick={toggleExpand} isOpen={isExpanded} />
        </div>
    ) : (
        <div className={css.dropdown}>
            <img src={imgUrl} alt="fragment-img" className={css.image} />
            <div className={css.titleContainer}>
                {fragmentTitle}
                <DropdownButton onClick={toggleExpand} isOpen={isExpanded} />
            </div>
        </div>
    );
};
